module.exports = __webpack_public_path__ + "static/img/form.287d5b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/form.svg
// module id = 397
// module chunks = 12